import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgGreyCheckmark = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9.667.577C4.469.577.243 4.803.243 10.001c0 5.197 4.226 9.423 9.424 9.423 5.197 0 9.423-4.226 9.423-9.423 0-5.198-4.226-9.424-9.423-9.424Zm0 18.258C4.793 18.835.832 14.875.832 10c0-4.873 3.961-8.834 8.835-8.834 4.873 0 8.834 3.96 8.834 8.835 0 4.873-3.96 8.834-8.834 8.834Z"
        fill="#374151"
      />
      <path
        d="m8.047 13.122-3.033-3.033-.412.412 3.445 3.446 6.685-6.685-.412-.412-6.273 6.272Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgGreyCheckmark;
